/* eslint-disable react/prop-types */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { getJson } from 'session';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Acl } from 'modules/common/components/Acl';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import FindBirthCertificateModal from '../components/FindMarriageCertificateModal';
import VerifyReceipt from '../components/VerifyReceipt';
import UpdateModal from '../components/UpdateModal';
import UpdateRegistry from '../components/UpdateRegistry';
import * as action from '../action';
import * as c from '../constant';

function MarriageContent({
  transactionInfo,
  showTransaction,
  approveTransaction,
  clearTransaction,
  startAssessment,
  isAssessting,
  isLoading,
  match,
  taxpayer,
  selectedBirth,
  taxpayerProfile,
  permissions,
  approving,
}) {
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;

  const onStartAssessment = () => e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want start assessment?`,
      () => {
        startAssessment(selectedTransaction, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleEdit = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={data.included.module.attributes}
          id={data.id}
        />
      ),
      title: `Update Owner's Information`,
      modalSize: 'modal-md',
    });
  };

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = cString => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const handleDeliveryOption = e => {
    e.preventDefault();
    const status = _.get(transactionInfo, 'attributes.delivery_location') || 0;

    startAssessment(selectedBirth, () => {
      approveTransaction(
        selectedBirth,
        {
          remarks: status
            ? 'Document is ready for delivery'
            : 'Document is ready for pick-up',
          status: status ? 'FOR DELIVERY' : 'FOR PICK-UP',
        },
        () => {
          showTransaction(selectedBirth);
          setModal({ isOpen: false });
        }
      );
    });
  };

  const onReceive = e => {
    e.preventDefault();

    startAssessment(selectedBirth, () => {
      approveTransaction(
        selectedBirth,
        {
          remarks: 'The document was received',
          status: 'RECEIVED',
        },
        () => {
          showTransaction(selectedBirth);
          setModal({ isOpen: false });
        }
      );
    });
  };

  const onPickup = e => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure, you want to tag as for pick-up this application?',
      remarks => {
        startAssessment(selectedBirth, () => {
          approveTransaction(
            selectedBirth,
            {
              remarks,
              status: 'FOR PICK-UP',
            },
            () => {
              showTransaction(selectedBirth);
              setModal({ isOpen: false });
            }
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const RenderDeliveryOption = ({ status, loader }) => {
    return (
      <button
        disabled={loader}
        onClick={handleDeliveryOption}
        className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
        type="button"
      >
        {status ? 'Tag as for Delivery' : 'Tag as for Pick-up'}
      </button>
    );
  };

  const handleFindMarriageCertificate = type => e => {
    e.preventDefault();
    const extName = _.get(taxpayer, 'extension_name')
      ? _.get(taxpayer, 'extension_name')
      : '';
    const reTaxpayer = {
      ...taxpayer,
      extension_name: extName,
    };
    setModal({
      isOpen: true,
      content: (
        <FindBirthCertificateModal
          type={type}
          transactionInfo={transactionInfo}
          searchParams={reTaxpayer}
          id={selectedBirth}
        />
      ),
      title: `View Marriage Certificate`,
      modalSize: 'modal-xxl',
      noCloseButton: true,
    });
  };

  const handleUpdateRegistry = val => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateRegistry info={val} />,
      title: 'Update Registry Number ',
      modalSize: 'modal-md',
    });
  };

  const showVerifyReceipt = status => {
    return [
      'WAITING FOR PAYMENT',
      'PAID',
      'FOR PICK-UP',
      'FOR PRINTING',
      'PENDING',
      'EXPIRED REFERENCE NUMBER',
    ].includes(status);
  };

  const handleVerifyReceipt = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt transactionInfo={transactionInfo} id={selectedBirth} />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1 ">
              {/* BORDER */}
              <div className="card border-primary p-2">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayerProfile, 'photo') !==
                        '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(taxpayerProfile, 'photo')}
                          />
                        ) : (
                          getInitials(
                            `${_.get(taxpayer, 'husband_first_name')} ${_.get(
                              taxpayer,
                              'husband_middle_name'
                            )} ${_.get(taxpayer, 'husband_last_name')} ${_.get(
                              taxpayer,
                              'wife_first_name'
                            )} ${_.get(taxpayer, 'wife_middle_name')} ${_.get(
                              taxpayer,
                              'wife_last_name'
                            )}`
                          )
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'husband_first_name')} ${_.get(
                          taxpayer,
                          'husband_middle_name'
                        ) || ''} ${_.get(
                          taxpayer,
                          'husband_last_name'
                        )} & ${_.get(taxpayer, 'wife_first_name')} ${_.get(
                          taxpayer,
                          'wife_middle_name'
                        ) || ''} ${_.get(taxpayer, 'wife_last_name')}`}
                      </h1>
                    </div>
                  </div>
                  <div className="d-flex ml-auto justify-content-end mb-3">
                    {showVerifyReceipt(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) && (
                      <button
                        onClick={handleVerifyReceipt}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                        type="button"
                      >
                        Assess Payment Receipt
                      </button>
                    )}
                    {['FOR CHECKING'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 &&
                      +_.get(
                        transactionInfo,
                        'attributes.is_start_assessment'
                      ) === 1 &&
                      Acl(permissions, ['FIND MARRIAGE CERTIFICATE']) && (
                        <button
                          type="button"
                          onClick={handleFindMarriageCertificate('check')}
                          className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                        >
                          View Marriage Certificates &nbsp;&nbsp;
                          <i className="fas fa-search" />
                        </button>
                      )}
                    {['PRINTED'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 &&
                      +_.get(
                        transactionInfo,
                        'attributes.is_start_assessment'
                      ) === 0 &&
                      Acl(permissions, ['RECEIVE MARRIAGE CERTIFICATE']) && (
                        <RenderDeliveryOption
                          loader={approving || isAssessting}
                          status={_.get(
                            transactionInfo,
                            'attributes.delivery_location'
                          )}
                        />
                      )}
                    &nbsp;
                    {['FOR CHECKING'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 &&
                      +_.get(
                        transactionInfo,
                        'attributes.is_start_assessment'
                      ) === 0 &&
                      Acl(permissions, [
                        'START ASSESSMENT MARRIAGE CERTIFICATE',
                      ]) && (
                        <button
                          type="button"
                          onClick={onStartAssessment(transactionInfo)}
                          className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                        >
                          Start Assessment &nbsp;&nbsp;
                          <i className="fas fa-check" />
                        </button>
                      )}
                    {['FOR DELIVERY', 'FOR PICK-UP'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 &&
                      +_.get(
                        transactionInfo,
                        'attributes.is_start_assessment'
                      ) === 0 &&
                      Acl(permissions, [
                        'START ASSESSMENT MARRIAGE CERTIFICATE',
                      ]) && (
                        <button
                          disabled={approving || isAssessting}
                          type="button"
                          onClick={onReceive}
                          className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                        >
                          Tag as Received &nbsp;&nbsp;
                          <i className="fas fa-check" />
                        </button>
                      )}
                    {['FOR DELIVERY'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 &&
                      +_.get(
                        transactionInfo,
                        'attributes.is_start_assessment'
                      ) === 0 &&
                      Acl(permissions, [
                        'START ASSESSMENT MARRIAGE CERTIFICATE',
                      ]) && (
                        <button
                          disabled={approving || isAssessting}
                          type="button"
                          onClick={onPickup}
                          className="gen-btn btn btn-danger font-weight-bold mr-1"
                        >
                          Tag as for PICK-UP &nbsp;&nbsp;
                          <i className="fas fa-check" />
                        </button>
                      )}
                    &nbsp;
                    {['FOR PRINTING'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 &&
                      Acl(permissions, ['VIEW MARRIAGE CERTIFICATE']) && (
                        <button
                          type="button"
                          onClick={handleFindMarriageCertificate('view')}
                          className="gen-btn btn btn-success font-weight-bold mr-1"
                        >
                          View Marriage Certificates &nbsp;&nbsp;
                          <i className="fas fa-list" />
                        </button>
                      )}
                    {['FOR CHECKING'].indexOf(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) > -1 && (
                      <button
                        onClick={handleEdit(transactionInfo)}
                        className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mr-1"
                        type="button"
                      >
                        Edit
                      </button>
                    )}
                    <button
                      onClick={handleUpdateRegistry(transactionInfo)}
                      className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                      type="button"
                    >
                      Update Registry No.
                    </button>
                  </div>

                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Document Information</Tab>
                    </TabList>
                    <TabPanel>
                      <TransactionInformation
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                        module="psa"
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="col-12 p-3">
                        <table className="transaction-table table table-borderless table-sm ">
                          <tbody>
                            <tr>
                              <td className="text-dark" width="300">
                                Registry Number
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'registry_number') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                No. of Copies
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {_.get(taxpayer, 'number_of_copies') || '--'}
                                </b>
                              </td>
                            </tr>

                            <tr>
                              <td className="text-dark" width="300">
                                What to Print
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'what_to_print') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-success" colSpan={3}>
                                <b>
                                  DOCUMENT OWNER&apos;s PERSONAL INFORMATION
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-primary" colSpan={3}>
                                <b>Name of the Man/Husband</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                Last Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'husband_last_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                Middle Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'husband_middle_name') ||
                                    '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                First Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'husband_first_name') ||
                                    '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-primary" colSpan={3}>
                                <b>Maiden Name of the Lady/Wife</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                Last Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'wife_last_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                Middle Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'wife_middle_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                First Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'wife_first_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            {/* <tr>
                              <td className="text-dark" width="300">
                                Extension Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'extension_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr> */}
                            <tr>
                              <td className="text-dark" width="300">
                                Date of Marriage
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {moment(
                                    _.get(taxpayer, 'date_marriage')
                                  ).format('YYYY-MM-DD') || '--'}
                                </b>
                              </td>
                            </tr>

                            <tr>
                              <td className="text-success" colSpan={3}>
                                <b>REQUESTOR&apos;s INFORMATION</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                Last Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'requestors_last_name') ||
                                    '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                First Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'requestors_first_name') ||
                                    '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                Middle Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'requestors_middle_name') ||
                                    '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                Relationship to the Owner
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(
                                      taxpayer,
                                      'relationship_to_the_owner'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>

                            <tr>
                              <td className="text-dark" width="300">
                                Telephone No.
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'telephone_number') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="300">
                                Mobile Number.
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(
                                      transactionInfo,
                                      'attributes.mobile_number'
                                    ) || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

MarriageContent.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  selectedBirth: PropTypes.string.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  isAssessting: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  isAssessting: _.get(api, 'loading', []).indexOf(c.START_ASSESSMENT) > -1,
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  approving: _.get(api, 'loading', []).indexOf(c.APPROVE_TRANSACTION) > -1,
  selectedBirth: _.get(match, 'params.id') || '',
  taxpayerProfile:
    _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(MarriageContent);
